<template>
  <a
    class="link"
    :href="url"
    :disabled="disabled"
    :target="newTab ? '_blank' : '_self'"
    rel="noopener noreferrer"
    @click="() => redirectRouter ? $router.push(redirectRouter) : $emit('click')"
  >
    <div class="link_icon" :icon="hasIcon">
      <slot name="icon"></slot>
    </div>
    {{ text }}
  </a>
</template>

<script>
export default {
  name: 'commonLink',
  props: {
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
    },
    newTab: {
      type: Boolean,
      default: true,
    },
    redirectRouter: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    src() {
      const image = `https://cdn.parcelex.com.br/assets/v2/${this.icon}-icon.svg`;
      return image;
    },
    hasIcon() {
      return !!this.$slots.icon;
    },
  },
};
</script>

<style lang="scss" scoped>
  .link {
    display: flex;
    flex-direction: row;
    justify-content: center;
    cursor: pointer;
    color: var(--primary);
    text-decoration: none;

    &:hover {
      color: var(--primary-dark);
    }

    &_icon {
      &[icon] {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 8px;
      }
    }

    &[disabled] {
      pointer-events: none;
      color: var(--gray-400);
    }
  }
</style>
